import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "lodash-es";
import { useParams } from "react-router-dom";
import { useApi } from "../../shared/api";

export const useFetchLeagues = (params = {}) => {
  const { fetchData } = useApi();
  const { organizationId, sport } = useParams();
  let URL = `${sport}/o/${organizationId}/leagues`;
  if (!isEmpty(params)) {
    URL += `?${new URLSearchParams(params)?.toString()}`;
  }

  return useQuery({
    queryKey: ["leagues", sport, organizationId, JSON.stringify(params)],
    queryFn: async () => {
      return await fetchData({
        url: URL,
      });
    },
  });
};
